import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import {
  FatalErrorCategoryEnum,
  FatalErrorReportModel,
} from 'src/app/shared/error/error.model';
import { defaultContentErrorReport } from 'src/app/shared/error/error-report-content';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  authErrorConfig,
  defaultAuthErrorConfig,
} from 'src/app/widget/data/auth-error-config';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-error-page',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent implements OnInit {
  supportURL = 'https://support.biodigital.com';
  isSceneJSError = false;
  viewSceneJSErrorDetails = false;
  sceneJSErrorReport: string;
  errorConfig: FatalErrorReportModel;
  sceneJSErrorTeaser: string;

  handleSeeDetailsClick() {
    this.viewSceneJSErrorDetails = true;
  }

  private buildSceneJSErrorReport(contentId: string, errorBlob: string) {
    return {
      contentId,
      error: JSON.parse(atob(errorBlob)),
      webglInfo: (window as any).SceneJS.WEBGL_INFO,
    };
  }

  get title(): string {
    return this.errorConfig.title;
  }

  get description(): string {
    return this.errorConfig.description;
  }

  constructor(private route: ActivatedRoute, private snackBar: MatSnackBar) {}

  ngOnInit() {
    const {
      errorType,
      errorCode,
      errorBlob,
      errorUrl,
    } = this.route.snapshot.queryParams;

    if (errorType === FatalErrorCategoryEnum.SceneJS) {
      this.isSceneJSError = true;
      const errorReport = this.buildSceneJSErrorReport(errorUrl, errorBlob);
      this.sceneJSErrorTeaser = errorReport.error.errorName;
      this.sceneJSErrorReport = JSON.stringify(errorReport, null, 2);
    } else if (errorType === FatalErrorCategoryEnum.Content) {
      this.errorConfig = defaultContentErrorReport;
    } else {
      this.errorConfig = authErrorConfig[errorCode] || defaultAuthErrorConfig;
    }
  }

  handleDownloadClick() {
    saveAs(
      new Blob([this.sceneJSErrorReport], { type: 'text/plain' }),
      'BioDigital_Error_Report.txt'
    );
  }

  handleActionClick(url: string) {
    // launch URL in new window
    const targetWindow = window.open(url);
    if (!targetWindow) {
      // notify user if blocked
      this.snackBar.open(
        'Unable to open link in new window, please check your pop-up settings.'
      );
    }
  }
}
